export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8811.8f9f6fff.jpg";